<template>
    <div class="g profile">
        <div class="g">
            <mdCaption
                :caption="$t('page.myaccount.caption.salesinfo')"
            ></mdCaption>
            <gCard>
                <div class="sales-info">
                    <div class="image">
                        <div class="cp user-photo is-smail">
                            <div class="figure">
                                <div
                                    class="img"
                                    :style="'background-image: url('+ sales.photo +');'"
                                >
                                    <img :src="sales.photo" :alt="sales.salename">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <div class="sales-name">
                            <span class="prop">{{ $t('page.myaccount.caption.representitive') }}</span>
                            <span class="value">
                                {{ sales.salename }}
                            </span>
                        </div>
                        <div class="sales-detail">
                            <ul>
                                <li>
                                    <span class="prop">E-mail</span>
                                    <span class="value">{{ sales.email }}</span>
                                </li>
                                <li>
                                    <span class="prop">{{ $t('site.noun.phone') }}</span>
                                    <span class="value">{{ sales.phone }}</span>
                                </li>
                                <li>
                                </li>
                            </ul>
                            <div class="btn">                
                                <cpBtn
                                    icon="sms"
                                    themes="warning"
                                    extendClass="is-hover"
                                    :text="$t('site.func.contactsales')"
                                    @click.prevent="talkOpen"
                                ></cpBtn>
                            </div>
                        </div>
                    </div>
                </div>
            </gCard>
            <mdCaption
                :caption="$t('page.myaccount.caption.download')"
            ></mdCaption>
            <gCard>
                <ul class="downloads-info">
                    <li class="in">
                        <cpBtn
                            icon="cloud_download"
                            :title="$t('page.mypurchase.func.downloadStatement')"
                            :text="$t('page.mypurchase.func.downloadStatement')"
                            extendClass="is-large is-block is-light"
                            themes= 'pure'
                            @click.prevent="downloadStatement"
                        ></cpBtn>
                    </li>
                    <li class="in">
                        <cpBtn
                            icon="cloud_download"
                            :title="$t('page.mypurchase.func.download')"
                            :text="$t('page.mypurchase.func.download')"
                            extendClass="is-large is-block is-light"
                            themes= 'pure'
                            @click.prevent="downloadShipping"
                        ></cpBtn>
                    </li>
                    <li class="in">
                        <cpBtn
                            icon="cloud_download"
                            :title="$t('page.myorders.func.downloadinvoice')"
                            :text="$t('page.myorders.func.downloadinvoice')"
                            extendClass="is-large is-block is-light"
                            themes= 'pure'
                            @click.prevent="downloadInvoice"
                        ></cpBtn>
                    </li>
                    <li class="in" v-if="user.co + user.div == '18'">
                        <cpBtn
                            icon="cloud_download"
                            :title="$t('page.myorders.func.downloadlistedprice')"
                            :text="$t('page.myorders.func.downloadlistedprice')"
                            extendClass="is-large is-block is-light"
                            themes= 'pure'
                            @click.prevent="downloadListedPrice"
                        ></cpBtn>
                    </li>
                </ul>
            </gCard>
            <mdCaption
                v-if="creditBalance !== null"
                :caption="$t('credit.caption.balance')"
            ></mdCaption>
            <gCard v-if="creditBalance !== null">
                <div class="credit-info">
                    <div class="info">
                        <div class="name">
                            <span class="value">{{ $t('credit.balance') }}</span>
                        </div>
                        <div class="detail">
                            <span
                                class="value"
                                :class="[creditBalance > 0? '': 'is-danger']"
                            >{{ 'NTD$ '+ $okaTool.numberToStringFormat(creditBalance) }}</span>
                            <cpLabel
                                v-if="computedCreditTime"
                                themes="info"
                                :text="$t('last.update') +' '+ computedCreditTime"
                            ></cpLabel>
                            <!-- <cpBtn
                                icon="refresh"
                                themes="info"
                                :title="$t('site.func.reload')"

                                @click.prevent="reloadCredit"
                            ></cpBtn> -->
                        </div>
                    </div>
                </div>
            </gCard>
            <template
                v-if="discountCuno && !$okaTool.isEmptyObj(allowanceBar)"
            >
                <mdCaption
                    :caption="$t('page.myaccount.caption.discont')"
                ></mdCaption>
                <gCard>
                    <div
                        class="md rate"
                        v-for="(item, key) in allowanceBar"
                        :key="key"
                    >
                        <div class="text">
                            {{ key }}
                            
                            {{ $t('page.shoppingcart.discont.current.discount') }}:
                            <cpLabel
                                themes="danger"
                                :text="item.range[item.current].discount"
                            ></cpLabel>
                            {{ $t('page.shoppingcart.discont.current.range') }}:
                            <cpLabel
                                themes="danger"
                                :text="item.range[item.current].qty"
                            ></cpLabel>
                            {{ $t('page.shoppingcart.discont.total.qty') }}:
                            <cpLabel
                                themes="danger"
                                :text="item.total"
                            ></cpLabel>
                        </div>
                        <cpRate
                            :range="item.range"
                            :current="item.current"
                            v-model="item.value"
                        ></cpRate>
                        <div class="text">{{ $t('page.shoppingcart.discont.explane', {
                            qty: $okaTool.numberToStringFormat(item.range[item.value].qty),
                            discount: item.range[item.value].discount,
                        }) }}</div>
                    </div>
                </gCard>
            </template>
        </div>
        <div class="g">
            <mdCaption
                :caption="$t('page.myaccount.caption.accinfo')"
            ></mdCaption>
            <gCard>
                <div class="md singup">
                    <div class="fieldset">
                        <div class="cp user-photo">
                            <div class="figure">
                                <div
                                    class="img"
                                    :style="'background-image: url('+ userPhoto +');'"
                                >
                                    <img :src="userPhoto" :alt="user.cuno">
                                </div>
                            </div>
                            <ul class="func">
                                <li><a @click="updatePhoto">{{ $t('page.myaccount.func.uploadpic') }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>{{ $t('page.myaccount.item.fulltitle') }}</label>
                        <div class="cp input text" disabled>
                            <input v-model="user.cufn" type="text" disabled>
                        </div>
                    </div>
                    <div class="center">
                        <div class="left">
                            <div class="fieldset">
                                <label>{{ $t('site.noun.userid') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.accountid" type="text" disabled>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('page.profile.item.companyrep') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.bos" type="text" disabled>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('site.noun.phone') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.phone" type="text" disabled>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>E-mail</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.email" type="text" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="fieldset">
                                <label>{{ $t('site.noun.password') }}</label>
                                <div class="div is-flex">
                                    <div class="cp input text" disabled>
                                        <input value="**********" type="text" disabled>
                                    </div>
                                    <cpBtn
                                        icon="edit"
                                        themes="major"
                                        :title="$t('site.func.edit')"

                                        @click.prevent="changePassword"
                                    ></cpBtn>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('page.profile.item.businessregisration') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.certificate" type="text" disabled>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('page.profile.item.cell') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.cellphone" type="text" disabled>
                                </div>
                            </div>
                            <div class="fieldset">
                                <label>{{ $t('site.noun.taxid') }}</label>
                                <div class="cp input text" disabled>
                                    <input :value="user.rfno" type="text" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fieldset">
                        <label>
                            {{ $t('site.noun.service') }}
                        </label>
                        <div class="cp input textarea" disabled>
                            <textarea :value="user.magtit" disabled></textarea>
                        </div>
                    </div>
                </div>
            </gCard>
        </div>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import gCard from '@/components/gCard'
    import mdInfoBoard from '@/components/mdInfoBoard'
    import cpLabel from '@/components/cpLabel'
    import cpBtn from '@/components/cpBtn'
    import cpRate from '@/components/cpRate'

    import { mapState, mapGetters, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            gCard,
            mdInfoBoard,
            cpLabel,
            cpBtn,
            cpRate,
        },
        data: function(){

            return {
                sales: {},
                allowanceBar: {},
            }
        },
        computed: {
            ...mapState([
                'user',
                'talk',
                'creditBalance',
                'creditTime',
                'unDiscountCuno',
            ]),
            ...mapGetters([
                'userPhoto',
            ]),
            computedCreditTime: function(){
                let _time = this.creditTime || '';

                return _time.replaceAll('-', '/').replace('T', ' ').replace(/\:\d\d\.\d\d\d$/, '')
            },
            discountCuno: function(){
                return !this.unDiscountCuno.includes(this.user.cuno);
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
                'changeState',
                'talkCreate',
                'initCredit',
                'pushNotification',
            ]),
            updatePhoto: function(){
                
                let $_addImage = (opt) =>{
                        let $formData = new FormData(),
                            $opt = opt[0];

                        let _url = this.$siteTool.apiUrl({
                                class: 'Upload',
                                func: 'Selfie',
                            });

                        $formData.append('file', $opt) //放進上傳的檔案

                        this.$http.post(_url, $formData).then(res => { //弄完所有設定後開始取資料
                            let $reader = new FileReader();

                            $reader.onload = (e) => {
                                this.changeState({
                                    timestamp: this.$okaTool.getUUID(),
                                });
                            }

                            $reader.readAsDataURL($opt);

                            this.pushNotification({
                                type: 'notification',
                                content: {
                                    html: this.$t('site.status.publishsuccess'),
                                }
                            });
                        }).catch(error => {

                            this.pushNotification({
                                type: 'notification',
                                content: {
                                    html: this.$siteConfig.publishError,
                                    status: 'danger'
                                }
                            });

                            this.sendError({
                                error: error
                            });
                        });
                    }

                this.pushPopUp({
                    type: 'uploadInput',
                    content: {
                        caption: this.$t('popup.profilepic.caption.uploadmsg'),
                        hideLabel: true,
                        html: '<div class="cp status is-warning icon-font warning">' + this.$t('popup.profilepic.caption.uploadjpg') + '</div>',
                        accept: '.jpg',
                        validate: 'required',
                        action: $_addImage
                    }
                });
            },
            downloadShipping: function(){
                let $_core = (startDate, endDate, callback) => {
                        let _url = this.$siteTool.apiUrl({
                                class: 'Order',
                                func: 'Download',
                            }),
                            $condition = {
                                startdate: startDate,
                                enddate: endDate,
                            }

                        try{
                            this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                                this.$siteTool.download(res)
                            });

                            if( callback && typeof callback === 'function' ) {
                                callback();
                            }
                        } 
                        catch(error) {

                            this.catchError({
                                error: error,
                                callback: () => {
                                    $_core(startDate, endDate);
                                },
                            });
                        }
                    }

                this.pushPopUp({
                    type: 'downloadShipping',
                    content: {
                        action: $_core,
                    }
                });
            },
            downloadListedPrice: function() {
                let _url = this.$siteTool.apiUrl({
                        class: 'PriceList',
                        func: 'Download',
                    })
                
                try{
                    this.$http.post(_url, {} ,{ responseType: 'blob' }).then(res=>{
                        this.$siteTool.download(res)
                    });

                } 
                catch(error) {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.downloadListedPrice()
                        },
                    });
                }
            },
            downloadInvoice: function(){
                let $_core = (condition) => {

                    let _url = this.$siteTool.apiUrl({
                            class: 'Invoice',
                            func: 'DownloadMonth',
                        }),
                        $condition = {
                            startdate: condition.startDate,
                            enddate: condition.endDate,
                        }

                    let $startLimit = this.$okaTool.timeInterval({
                        time: new Date(condition.startDate),
                        unit: 'date',
                        away: '>',
                        int: 30
                    }).ymd.replaceAll('/', '-')

                    try{

                        if( $startLimit < condition.endDate ){//如果選擇區間超過30天，就要出現提示
                            throw {
                                    code: this.$t('page.download.item.date_alert'),
                                    message: this.$t('page.download.item.date_selection_alert')
                                }
                        }
                        this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                            this.$siteTool.download(res)
                        }).catch(error =>{
                            this.catchError({
                                error: error,
                                callback: () => {
                                    $_action($result);
                                },
                            });
                        });
                    } 
                    catch(error) {

                        this.catchError({
                            error: error,
                            callback: () => {
                                $_core(startDate, endDate);
                            },
                        });
                    }
                }

                let $title = [
                    {  
                        caption: this.$t('site.noun.startdate'),
                        prop: 'startDate',
                        showtype: 'date',
                        sortable: true,
                        sort: '',
                        inputtype: 'date',
                        visible: true,
                        validate: 'required',
                        showtype: 'input',
                        editable: true
                    },
                    {  
                        caption: this.$t('site.noun.enddate'),
                        prop: 'endDate',
                        showtype: 'date',
                        sortable: true,
                        sort: '',
                        inputtype: 'date',
                        visible: true,
                        validate: 'required|equalAfter:startDate',
                        showtype: 'input',
                        editable: true
                    }
                ] 

                let $today = this.$okaTool.timeInterval({
                        unit: 'date',
                        time: new Date()
                    }),
                    $tenDayBefore = this.$okaTool.timeInterval({
                        unit: 'date',
                        time: new Date(),
                        away: '<',
                        int: 30
                    })

                this.pushPopUp({
                    type: 'editSingle',
                    content: {
                        caption: this.$t('page.myorders.func.downloadinvoice'),
                        minorCaption: '資料量大請耐心等候',
                        title: $title,
                        node: {
                            startDate: $tenDayBefore.ymd,
                            endDate: $today.ymd,
                        },
                        action: (condition)=>{
                            $_core(condition);
                        },
                        width: 400,
                    },
                    
                });
            },
            downloadStatement: function(){
                let $_core = (date, callback) => {
                
                        let _url = this.$siteTool.apiUrl({
                                class: 'Statement',
                                func: 'Download',
                            }),
                            $condition = {
                                ym: date,
                            }
                        
                        try{
                            this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                                this.$siteTool.download(res)
                            });

                            if( callback && typeof callback === 'function' ) {
                                callback();
                            }
                        }catch(error) {

                            this.catchError({
                                error: error,
                                callback: () => {
                                    $_core(date);
                                },
                            });
                        }
                    }

                this.pushPopUp({
                    type: 'downloadStatement',
                    content: {
                        action: $_core,
                    }
                });
            },
            changePassword: function(){
                
                this.pushPopUp({
                    type: 'changePassword',
                });
            },
            talkOpen: async function(){
                let _saleid = this.sales.saleid;

                if( this.$siteConfig.devEvent ) { //測試機就給我
                    _saleid = 'n000170609'
                }

                let _url = this.$siteConfig.talkAccountUrl,
                    $form = new URLSearchParams({
                        account: _saleid,
                        accessToken: this.talk.accessToken,
                    });
                    
                try {
                    let $response = await this.$http.post(_url, $form),
                        $data = $response.data;
                   
                    if( $data.result === 'SUCCESS' ) {
                        this.talkCreate($data.data.aid); //創造一個聊天
                    }else {
                        console.error($data);
                    }

                }catch(error) {
                    console.log(error)
                }
            },
            reloadCredit: function(){

                this.initCredit(() => {

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.syncSuccess'),
                            status: 'success'
                        }
                    });
                });
            },
            getDiscount: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Discount',
                    });

                let $today = new Date(),
                    _year = $today.getFullYear(),
                    _month = this.$okaTool.doubleCount($today.getMonth() + 1);

                let _date = _year +'-'+ _month + '-01';

                return this.$http.post(_url, {
                        dDate: _date,
                    });
            },
            initDiscount: function(data){
                let $result = {}

                let $user = this.user,
                    _co = $user.co,
                    _div = $user.div,
                    _codiv = _co + _div;

                let $discountData = data || [],
                    $allowanceTable = this.$siteConfig.allowanceTable || {},
                    $allowanceDivTable = $allowanceTable[_codiv] || {},
                    $allowanceDivTableKeys = Object.keys($allowanceDivTable);
                
                $allowanceDivTableKeys.forEach(key => {
                    let $target = $discountData.find(discountData => key === discountData.classify);

                    if( !$target ) {
                        $discountData.push({
                            aoqty: 0,
                            classify: key,
                            codiv: _codiv,
                            discount: 0,
                            un: 'KG',
                        });
                    }
                });

                $discountData.forEach(discountData => {
                    let _type = discountData.classify,
                        $typeDiscount = $allowanceDivTable[_type]

                    let _total = discountData.aoqty || 0,
                        _current = 0,
                        $range = []

                    let $levelList = Object.keys($typeDiscount); //[15000, 30000...]

                    $levelList = $levelList.map(item => parseInt(item, 10));

                    $levelList.sort((a, b) => a < b? -1: 1); //[200000, 100000...]

                    $levelList.forEach((item, index) => {

                        if( _total >= item ) {
                            _current = index;
                        }

                        $range.push({
                            discount: $typeDiscount[item],
                            qty: this.$okaTool.numberToStringFormat(item),
                        });
                    });

                    let _value = _current;

                    if( _value < $levelList.length - 1 ) {
                        _value += 1;
                    }

                    $result[_type] = {
                        value: _value,
                        current: _current,
                        total: this.$okaTool.numberToStringFormat(_total),
                        range: $range,
                    }
                });

                this.$set(this, 'allowanceBar', $result);
            },
            getSales: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'ContactSales',
                        func: 'Info',
                    });

                return this.$http.post(_url, {});
            },
            initSales: function(data){
                this.$set(this, 'sales', data);
            },
            init: async function(){

                try {
                    let $response = await Promise.all([
                            this.getSales(),
                            this.getDiscount(),
                        ]);
                    
                    let [sales, discount] = $response;

                    this.initSales(sales);
                    this.initDiscount(discount);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
        },
        created: function(){
            this.initCredit();
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .g.profile {
        // max-width: 760px;
        // margin: 0 auto;
    }

    .g.card {
        position: relative;
    }

    .cp.user-photo {
        $size: 144px;
        $lh: 36px;

        position: relative;
        width: $size;
        margin: 0 auto;
        border-radius: 100px;
        border: 1px solid $gray;
        overflow: hidden;

        &.is-smail {
            $size-s: 96px;
            $lh-s: 24px;

            width: $size-s;

            &:hover {

                .func {
                    top: $size-s - $lh-s;
                }
            }

            .figure {
                height: $size-s;

                &::after {
                    line-height: $size-s;
                    font-size: $size-s;
                }
            }

            /*ul*/.func {
                top: $size-s;

                li {

                }

                a {
                    line-height: $lh-s;
                }
            }
        }

        &:hover {

            .func {
                top: $size - $lh;
            }
        }

        .figure {
            position: relative;
            height: $size;
            text-align: center;
            background-color: $white;

            .img {
                @extend %fill-image;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
        
                img {
                    display: none;
                }
            }

            &::after {
                @extend %font-pseudo;
                content: '\e87c';
                display: block;
                line-height: $size;
                font-size: $size;
                color: $major-color;
            }
        }

        /*ul*/.func {
            @extend %reset;
            transition: $transition;
            position: absolute;
            top: $size;
            left: 0;
            right: 0;

            li {

            }

            a {
                display: block;
                line-height: $lh;
                text-align: center;
                color: $white;
                background-color: rgba-set($black, $opacity-h);
                cursor: pointer;
            }
        }
    }
    
    ul.downloads-info{
        @extend %reset;
        display: flex;
        flex-wrap: wrap;

        li.in {
            padding: $interval-s;
            flex-basis: 25%;
            max-width: 25%;
            box-sizing: border-box;

            @include media('pad') {
                flex-basis: 50%;
                max-width: 50%;
            }

            @include media('phone') {
                flex-basis: 100%;
                max-width: 100%;
            }
        }
    }

    .credit {

        .price {
            $type: map-get($colors, 'danger');
            $text: map-get($type, 'text');

            font-size: $font-size-xxxl;
            color: $text;
            font-weight: bold;
            line-height: 101px;
        }
    }

    .credit-info {
        display: flex;
        justify-content: center;

        @include media('mobile') {
            flex-direction: column;
        }

        .info {
            margin-left: $interval-xl;
            display: flex;
            align-items: center;

            @include media('mobile') {
                margin-left: 0;
                justify-content: center;
            }

            @include media('phone') {
                flex-direction: column;
            }
        }

        .name {
            width: 377px;
            text-align: right;

            @include media('phone') {
                width: auto;
                text-align: center;
            }

            .value {
                font-size: $font-size-xxxl;
            }
        }

        .detail {
            margin-left: $interval-xl;
            border-left: $border;
            padding-left: $interval-xl;

            @include media('phone') {
                margin-left: 0;
                border-width: 0;
                margin-top: $interval-m;
                text-align: center;
            }

            .value {
                font-size: $font-size-xxxl;
                color: $major-color;
                vertical-align: text-top;
                margin-right: $interval-s;

                &.is-danger {
                    $type: map-get($colors, 'danger');
                    $text: map-get($type, 'text');

                    color: $text;
                }
            }
        }
    }

    .sales-info {
        display: flex;
        justify-content: center;

        @include media('mobile') {
            flex-direction: column;
        }

        .image {
            
        }

        .info {
            margin-left: $interval-xl;
            display: flex;
            align-items: center;

            @include media('mobile') {
                margin-left: 0;
                margin-top: $interval-xl;
                justify-content: center;
            }

            @include media('phone') {
                flex-direction: column;
            }

            .sales-name {
                flex-shrink: 0;

                .prop {
                    display: block;
                    font-size: $font-size-l;
                }

                .value {
                    display: block;
                    font-size: $font-size-xxxl;
                }
            }

            .sales-detail {
                margin-left: $interval-xl;
                border-left: $border;
                padding-left: $interval-xl;

                @include media('phone') {
                    margin-left: 0;
                    border-width: 0;
                    margin-top: $interval-xl;
                }

                ul {
                    @extend %reset;
                }

                li {
                    @extend %ellipsis;
                    font-size: $font-size-l;
                    display: flow-root;
                    
                    + li {
                        margin-top: $interval-m;
                    }
                }

                .prop {

                    &::after {
                        content: ': ';
                    }
                }

                .value {

                }
            }

            .btn {
                position: absolute;
                bottom: $interval-s;
                right: $interval-s;

                @include media('phone') {
                    position: static;
                    text-align: center;
                }
            }
        }
    }

    .md.singup {
        // background-color: $gray;
        // padding: $interval-l $interval-xl;
        // border-radius: $border-radius;

        .center {
            display: flex;

            @include media('mobile') {
                display: block;
            }
        }

        .left {
            flex: 1;
            padding-right: $interval-s;

            @include media('mobile') {
                padding-right: 0;
            }
        }

        .right {
            flex: 1;
            padding-left: $interval-s;

            @include media('mobile') {
                padding-left: 0;
            }
        }

        .fieldset {
            padding: $interval-xs 0;
            margin-bottom: $interval-m;

            .is-flex {
                display: flex;

                .cp.input {
                    flex: 1;
                }
            }

            > .cp.input {
                display: block;
                width: auto;

                > div, input, textarea {
                    width: 100%;

                    &[disabled] {
                        cursor: pointer !important;
                    }
                }

                textarea {
                    height: 80px;
                }
            }

            label {
                display: block;
                margin-bottom: $interval-xs;
            }
        }

        .span {
            cursor: pointer;

            &:hover {
                transition: $transition;
                opacity: $opacity-m;
            }
        }
    }

    .md.rate {

        + .md.rate {
            margin-top: $interval-m;
            border-top: $border;
            padding-top: $interval-m;
        }

        .text {
            padding: $interval-m;
        }
    }
</style>
 